'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var $ = _interopDefault(require('jquery'));
var utils_js = require('../helpers/utils.js');

/**
 * A set of helpers for common actions utilized to improve site accessibility.
 *
 * By default, it attaches event handlers to all links with a class of .in-page-link to correctly set
 * focus on the target destination. Additional methods described below help with managing focus state.
 *
 * @class A11yHelpers
 * @namespace ShopifyMarketing
 * @constructor
*/
function A11yHelpers() {
  var _this = this;

  this.init();

  $('.in-page-link').on('click', function (evt) {
    _this.pageLinkFocus(utils_js.getJQueryObjectFromHash(evt.currentTarget.hash));
  });
}

A11yHelpers.prototype.init = function () {
  // on init, check if we need to set page focus
  this.pageLinkFocus(utils_js.getJQueryObjectFromHash(window.location.hash));
};

/**
 * Modifies the `tab` order to prevents focus from exiting a given container,
 * e.g. a modal or a drawer.
 * @method trapFocus
 * @param {DOM element} container Target element in which to trap focus
 * @param {String} [eventNamespace] Custom namespace for jQuery event binding
*/
A11yHelpers.prototype.trapFocus = function (container, eventNamespace) {
  var $container = utils_js.isJquery(container) ? container : $(container);
  var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

  $container.attr('tabindex', '-1');

  $(document).on(eventName, function (evt) {
    if ($container[0] !== evt.target && !$container.has(evt.target).length) {
      $container.focus();
    }
  });
};

/**
 * Remove focus trap added via `trapFocus()`.
 * @method removeTrapFocus
 * @param {DOM element} container Target element in which focus is trapped
 * @param {String} [eventNamespace] Custom namespace for jQuery event binding
*/
A11yHelpers.prototype.removeTrapFocus = function (container, eventNamespace) {
  var $container = utils_js.isJquery(container) ? container : $(container);
  var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

  $container.removeAttr('tabindex');
  $(document).off(eventName);
};

/**
 * For use when focus shifts to a container rather than a link, e.g., for
 * in-page links, after scroll, focus shifts to content area so that the next
 * item in the `tab` order is what the user expects.
 *
 * If focusing a link, just use $link.focus();
 * @method pageLinkFocus
 * @param {DOM element} element Target element for focus
*/
A11yHelpers.prototype.pageLinkFocus = function (element) {
  var $element = utils_js.isJquery(element) ? element : $(element);
  if (!$element.length) {
    return;
  }
  $element.get(0).tabIndex = -1;
  $element.focus().addClass('js-focus-hidden');
  $element.one('blur', function () {
    $element.removeClass('js-focus-hidden').removeAttr('tabindex');
  });
};

module.exports = A11yHelpers;
